<template>
    <div class="faceCollectWarp">
        <h3 class="tx-c faceCollect-header">人脸采集审批</h3>
        <div class="searchBox">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item label="姓名">
                    <el-input v-model="searchForm.username" placeholder="审批人"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input v-model="searchForm.IDCard" placeholder="审批人"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="searchForm.phone" placeholder="审批人"></el-input>
                </el-form-item>           
                <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                    <el-button type="primary" @click="approvalFaceData('1')">通过</el-button>
                    <el-button type="primary" @click="approvalFaceData('2')">不通过</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table
            border
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            stripe
            @selection-change="selectionChange"
            >
            <el-table-column 
                type="selection" 
                width="55"
                :selectable='selectEnable'>
            </el-table-column>
            <el-table-column
                type="index"
                label="序号"
                width="65"
                align="center"
            ></el-table-column>
            <el-table-column
                prop="userName"
                label="姓名"
                width="200"
                align="center"
                show-overflow-tooltip
            >
            </el-table-column>    
            <el-table-column
                prop="sex"
                label="性别"
                width="100"
                align="center"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    {{scope.row.sex | sexName}}
                </template>
            </el-table-column>    
            <el-table-column
                prop="identityCard"
                label="身份证号"
                width="200"
                align="center"
                show-overflow-tooltip
            >
            </el-table-column>    
            <el-table-column
                prop="phone"
                label="手机号"
                width="200"
                align="center"
                show-overflow-tooltip
            >
            </el-table-column>    
            <el-table-column
                prop="endTime"
                label="到期时间"
                width="200"
                align="center"
                show-overflow-tooltip
            >
            </el-table-column>    
            <el-table-column
                prop="startTime"
                label="创建时间"
                width="200"
                align="center"
                show-overflow-tooltip
            >
            </el-table-column>    
            <el-table-column
                prop="state"
                label="审批状态"
                width="150"
                align="center"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    {{scope.row.state | stateName}}
                </template>
            </el-table-column>    
            <el-table-column
                label="操作"
                width="150"
                align="center"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <el-button
                        size="small "
                        @click="watchDetail(scope.row)"
                    ><span>详情</span>
                    </el-button>
                </template>
            </el-table-column>    
        </el-table>
        <el-dialog title="审批意见" :visible.sync="dialogApprovalVisible" width="30%" append-to-body>
            <el-input
                type="textarea"
                :rows="4"
                show-word-limit
                maxlength="300"
                placeholder="请输入审批意见"
                v-model="approvalOpinions">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button  type="primary" @click="confirmApproval">确定</el-button>
                <el-button  @click="cancelApproval">取消</el-button>
            </span>
        </el-dialog>
        <el-dialog title="人脸信息详情" :visible.sync="approvalDetailVisible" width="40%" append-to-body :modal="false" center>
            <div>
                <div class="detail-item">
                    <div class="detail-title">姓名:</div>
                    <div class="detail-content">{{detailForm.userName}}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-title">性别:</div>
                    <div class="detail-content">{{detailForm.sex == "1" ? '男' : '女'}}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-title">证件类型:</div>
                    <div class="detail-content">{{detailForm.certificateType == "111" ? "身份证" : "其他"}}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-title">证件号码:</div>
                    <div class="detail-content">{{detailForm.identityCard}}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-title">照片:</div>
                    <div class="detail-content">
                        <img v-if="detailForm.url && detailForm.url != '无'" class="detail-content-img" :src="detailForm.url">
                    </div>
                </div>
                <div class="detail-item">
                    <div class="detail-title">联系电话:</div>
                    <div class="detail-content">{{detailForm.phone}}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-title">登记类型:</div>
                    <div class="detail-content">{{detailForm.checkTypeName}}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-title">到期时间:</div>
                    <div class="detail-content">{{detailForm.endTime}}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-title">楼栋号:</div>
                    <div class="detail-content">{{detailForm.buildingNumber}}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-title">房屋编号:</div>
                    <div class="detail-content">{{detailForm.houseNumber}}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-title">备注:</div>
                    <div class="detail-content">{{detailForm.remark}}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-title">审批意见:</div>
                    <div class="detail-content">{{detailForm.opinions}}</div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button  @click="approvalDetailVisible = false">关闭</el-button>
            </span>
        </el-dialog>
        <!-- 分页start -->
        <!-- v-if="this.selectUser.total > 0" -->
        <div style="margin-top: 10px;text-align:left;">
            <el-pagination
                background
                @current-change="UserCurrentChange"
                :current-page.sync="selectUser.current"
                layout="total,prev, pager, next"
                :total="selectUser.total"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { faceRecognitionAllInfoPage, faceRecognitionAudit, faceRecognitionAuditByList} from "@/api/faceCollectApproval/faceCollectApproval.js"
export default {
    name: 'faceCollectApproval',

    data() {
        return {
            searchForm: {
                
            },
            tableData: [], 
            selectUser: {
                current: 1,
                pageSize: 10,
                total: 0
            },
            selectionData: [],
            dialogApprovalVisible: false,
            approvalDetailVisible: false,
            approvalState: "",
            approvalOpinions: "",//填写的审核意见
            detailForm: {},
        };
    },

    mounted() {
        this.initPage();
    },
    watch:{
        dialogApprovalVisible(newV,oldV){
            if (!newV) {
                this.approvalOpinions = "";
            }
        }
    },
    filters:{
        sexName(value){
            if (value == "0") {
                return "女"
            } else if (value == "1"){
                return "男"
            }
        },
        stateName(val){
            if (val == 0) {
                return "审核中";
            } else if (val == 1) {
                return "通过";
            } else if (val == 2) {
                return "不通过";
            };       
        }
    },
    methods: {
        search(){
            this.selectUser.current = 1;
            this.initPage();
        },
        confirmApproval(){
            if (!this.approvalOpinions) {
                this.$message.warning('请输入审批意见')
                return;
            };
            if (this.selectionData.length == 1) {
                const params = {
                    id: this.selectionData[0].id,
                    state: this.approvalState,
                };
                faceRecognitionAudit(params).then(({data}) => {
                    if (data.code == 0) {
                        this.$message.success("审批成功");
                        this.dialogApprovalVisible = false;
                        this.initPage();
                    } else {
                        this.$message.warning(data.msg)
                    }
                });
            } else if (this.selectionData.length > 1) {
                let idString = "";
                this.selectionData.forEach(item => {
                    idString = idString + item.id + ","
                })
                const params = {
                    id: idString,
                    state: this.approvalState,
                };
                faceRecognitionAuditByList(params).then(({data}) => {
                    if (data.code == 0) {
                        this.$message.success("审批成功");
                        this.dialogApprovalVisible = false;
                        this.initPage();
                    } else {
                        this.$message.warning(data.msg)
                    }
                })
            }
        },
        cancelApproval(){
            this.dialogApprovalVisible = false;
        },
        watchDetail(row){
            this.approvalDetailVisible = true;
            this.detailForm = JSON.parse(JSON.stringify(row));
            if (this.detailForm.checkType == "1") {
                this.detailForm.checkTypeName = "租户"
            } else if (this.detailForm.checkType == "2") {
                this.detailForm.checkTypeName = "家属"
            } else if (this.detailForm.checkType == "3") {
                this.detailForm.checkTypeName = "住户"
            }
        },
        initPage(){
            const obj = {
                current: this.selectUser.current,
                pageSize: this.selectUser.pageSize, 
            }
            faceRecognitionAllInfoPage({...obj, ...this.searchForm}).then(({data}) => {
                if (data.code == 0) {
                    this.tableData = data.data.records;
                    this.selectUser.total = data.data.total;
                } else {
                    this.$message.warning(data.msg)
                }
            })
        },
        UserCurrentChange(val) {
            this.selectUser.current = val;
            this.initPage();
        },
        approvalFaceData(val){
            if (this.selectionData.length == 0) {
                this.$message.warning('请先勾选数据');
                return
            }
            this.dialogApprovalVisible = true;  
            this.approvalState = val;
        },
        selectionChange(selection) {
             this.selectionData = selection
        },
        selectEnable(row, rowIndex) {
            if (row.state == "0") {
                return true
            } else {
                return false
            }
        },
    },
};
</script>

<style  scoped>
.faceCollectWarp {
    width: 100%;
    height: 100%;
}
.faceCollect-header{
    margin-bottom: 30px;
}
.searchBox { 
    margin-bottom: 20px;
}
.approval-btn-warp{
    margin: 10px 0;
}
.approval-btn{
    text-align: right;
    margin-right:30px ;
}
.detail-item{
    display: flex;
    line-height: 40px;
}
.detail-item .detail-title{
    width:30%;
    text-align: right;
}
.detail-item .detail-content{
    width: 60%;
    text-align: center;
}
.detail-item .detail-content .detail-content-img{
    width: 200px;
    height: 200px;
}
</style>